(() => {
  const section = document.currentScript.closest(".announcement-banner");

  section.querySelector('[data-close]')?.addEventListener('click', ()=>{
      section.style.display = 'none';
      document.body.setAttribute('style', `--announcement-banner: 0px`)
  })

  document.body.setAttribute('style', `--announcement-banner: ${section.offsetHeight}px`)

  let { endDate } = section.dataset;
  console.log("endDate", endDate)

  document.addEventListener("DOMContentLoaded", function () {

      const timerWrapper = section.querySelector('.countdown__units')
      const timerWrapperItem = section.querySelector('span')
      timerWrapper.setAttribute('style', `--item-width: ${timerWrapperItem.offsetWidth}px`)

      endDate = new Date(new Date(`${endDate}`).toLocaleString("en-US", { timeZone: "Europe/Madrid" })).getTime()
      console.log("endDate", endDate)

      function updateCountdown() {
          let now = new Date(new Date().toLocaleString("en-US", { timeZone: "Europe/Madrid" })).getTime()

          const timeLeft = endDate - now;

          if (timeLeft <= 0) {
              clearInterval(intervalID);
              return
          }

          const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24))
          const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
          const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

          section.querySelector('#days').innerHTML = `${days}`.length === 1 ? `0${days}`: days;
          section.querySelector('#hours').innerHTML = `${hours}`.length === 1 ? `0${hours}`: hours;
          section.querySelector('#minutes').innerHTML = `${minutes}`.length == 1 ? `0${minutes}`: minutes;
          section.querySelector('#seconds').innerHTML = `${seconds}`.length === 1 ? `0${seconds}`: seconds;
      }

      const intervalID =  setInterval(updateCountdown, 1000);

      section.querySelector('[data-close]')?.addEventListener('click', ()=>{
          clearInterval(intervalID);
          section.style.display = 'none'
      })
  })
})();